import React, { FunctionComponent } from 'react';
import { Box, Link as MaterialLink } from '@material-ui/core';
import { useIntl } from 'react-intl';
import LabelAndPrice from '../../labels/LabelAndPrice';
import expandedSectionStyles from '../ExpandedSectionStyles';
import { IPrice } from '../../../../../../../../../common/model/IPrice';
import ICarConfigOption from '../../../../../../../../../common/model/ICarConfigOption';
import CustomTitle from '../../../../../presentational/customTitle/CustomTitle';
import Translation from '../../../../../../../common/components/translation/Translation';

export interface IOptionItemProps {
  option: ICarConfigOption;
  price: IPrice;
  category: string;
  removeAction: (category: string, optionId?: string) => void;
  decimalScale: number;
}

const OptionItem: FunctionComponent<IOptionItemProps> = ({ option, price, category, removeAction, decimalScale }) => {
  const styles = expandedSectionStyles();
  const intl = useIntl();

  return (
    <Box data-test={`summary_expanded:${category}:${option.id}`}>
      <LabelAndPrice
        label={
          <CustomTitle
            title={option.title}
            indicative={intl.formatMessage({ id: 'spc.customise.indicative.option' })}
          />
        }
        price={price?.basePrice}
        currency={price?.currency}
        priceType={option.title}
        isMainText={false}
        decimals={decimalScale}
      />
      <MaterialLink
        onClick={() => removeAction(category, option.id)}
        variant={'helpingText'}
        className={styles.changeAction}
        underline={'always'}
        color={'secondary'}
        data-test={`${category}:button:remove`}
      >
        <Translation id={'spc.customise.button.remove'} />
      </MaterialLink>
    </Box>
  );
};

export default OptionItem;
